import type { AdminRoute } from '@/routes/config';
import { UserRole } from '@/types/auth';

export function getRoutesForRole(
  routes: AdminRoute[],
  permissions: Record<string, readonly UserRole[]>,
  role?: UserRole,
) {
  if (!role) return [];
  if (role === UserRole.SUPER_ADMIN) return routes;
  return routes.filter((route) => permissions[route.path]?.includes(role));
}
